import { useRef } from "react";
import styled from "styled-components";
import PoolRow from "./PoolRow";
import BigNumber from "bignumber.js";
import { Box } from "@mui/material";

interface PoolsTableProps {
  pools: any;
  userDataLoaded: boolean;
  account: string;
  price: number,
}

export interface DeserializedPool {
  totalStaked?: BigNumber;
  stakingLimit?: BigNumber;
  stakingLimitEndBlock?: number;
  profileRequirement?: {
    required: boolean;
    thresholdPoints: BigNumber;
  };
  userData?: {
    allowance: BigNumber;
    stakingTokenBalance: BigNumber;
    stakedBalance: BigNumber;
    pendingReward: BigNumber;
  };
}

const StyledTable = styled.div`
  scroll-margin-top: 64px;
  background : #00202F;
  border-radius : 30px;

  > div:not(:last-child) {
    border-bottom: 2px solid #000B22;
  }
 
  `;

const StyledTableBorder = styled.div`
  padding: 1px 1px 3px 1px;
  margin-bottom: 50px;
  background-size: 400% 400%;
`;

const ScrollButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 5px;
  padding-bottom: 5px;
`;

const PoolsTable: React.FC<PoolsTableProps> = ({
  pools,
  userDataLoaded,
  account,
  price
}) => {
  // console.log(account)

  const tableWrapperEl = useRef<HTMLDivElement>(null);
  return (
    <>
      {pools.length !== 0 ?
        <StyledTableBorder>
          <StyledTable id="pools-table" role="table" ref={tableWrapperEl}>
            {pools.map((pool, index) => (

              <PoolRow
                key={pool.vaultKey ?? pool.sousId}
                pool={pool}
                index={index}
                account={account}
                price={price}
                userDataLoaded={userDataLoaded}
              />

            ))}
          </StyledTable>
        </StyledTableBorder>
        :
        // <Box sx={{ width: '100%', textAlign: 'center', color: 'white', fontSize: '16px', fontWeight: '400', lineHeight: '1.5' }}>
        //   No Pools
        // </Box>
        ''
      }
    </>
  );
};

export default PoolsTable;
